// extracted by mini-css-extract-plugin
export default {"container":"messagePage_container__8P+N5","negativeMex":"messagePage_negativeMex__Ju2I0","positiveMex":"messagePage_positiveMex__cmrLh","link":"messagePage_link__112P9"};